// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"35ddb1ed","423":"51c6ea4a","821":"13b5f3e2"}[chunkId] + ".chunk.css";
};